const namespace = 'leihbox-'
const names = {
  basket: `${namespace}basket`,
  remoteCartId: `${namespace}cartId`,
  rooms: `${namespace}rooms`,
  persons: `${namespace}persons`,
  startDate: `${namespace}startDate`,
  period: `${namespace}period`,
  isDev: `${namespace}isDev`,
  country: `${namespace}country`,
}

const Storage = {
  setRemoteCartId(id) {
    localStorage.setItem(names.remoteCartId, id)
  },
  getRemoteCartId() {
    return localStorage.getItem(names.remoteCartId) || null
  },
  setRooms(amount) {
    localStorage.setItem(names.rooms, amount)
  },
  getRoomsAmount() {
    return localStorage.getItem(names.rooms) || 0
  },
  setStartDate(date) {
    localStorage.setItem(names.date, date)
  },
  getStartDate() {
    return localStorage.getItem(names.date) || false
  },
  setPeriod(period) {
    localStorage.setItem(names.period, period)
  },
  getPeriod() {
    return localStorage.getItem(names.period) || false
  },
  setCountry(country) {
    localStorage.setItem(names.country, country)
  },
  getCountry() {
    return localStorage.getItem(names.country) || false
  },
  setBasket(items) {
    localStorage.setItem(names.basket, JSON.stringify(items))
  },
  getBasket() {
    const items = localStorage.getItem(names.basket)
    return JSON.parse(items) || []
  },
  getIsDev() {
    const items = localStorage.getItem(names.isDev)
    return items == 1
  },
}

export default Storage
